import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledP = styled(P)`
  font-weight: bold;
  padding-bottom: 7px;
`;
